<template>
	<div class="">
		<div class="information">
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_gr" src="../assets/personal.png" />
				</div>
				<input @focus="getFocus" v-model="peisonal_name" type="" name="" placeholder="请填写姓名" id="" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sfz" src="../assets/sfz.png" />
				</div>
				<!-- <input readonly="readonly" style="color: #b1b1b1;" @focus="getFocus" ref="inputFocus" v-model="peisonal_documentType" type="" name="" id="" value="" /> -->
				<select name="documentType" class="se" v-model="peisonal_documentType">
					<option value="请选择证件类型">请选择证件类型</option>
					<option value="中国大陆身份证">中国大陆身份证</option>
					<option value="港澳居民来往内地通行证">港澳居民来往内地通行证</option>
					<option value="台湾居民来往大陆通行证">台湾居民来往大陆通行证</option>
					<option value="护照">护照</option>
				</select>
				<img src="../assets/toBottom.png" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sfz" src="../assets/sfz.png" />
				</div>
				<input @focus="getFocus" v-model="peisonal_id" type="" name="" id="" placeholder="请填写身份证号" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/group_pass.png" />
				</div>
				<input @focus="getFocus" v-model="peisonal_pass" type="password" name="" id="" placeholder="请使用数字、大小写字母，特殊字符中3种组合成8-16位密码" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/group_pass.png" />
				</div>
				<input @focus="getFocus" v-model="peisonal_passYes" type="password" name="" id="" placeholder="请确认密码" value="" />
			</div>
			<div class="information_div" v-if="test=='false'">
				<div class="information_div_div">
					<img class="img_sfz" src="../assets/teamName.png" />
				</div>
				<van-field v-model="address" readonly clickable label="" :value="value" placeholder="选择所在地址" @click="showPicker = true" />
				<van-popup v-model="showPicker" position="bottom">
					<van-area :area-list="areaList" :columns-placeholder="['请选择', '请选择', '请选择']" @cancel="showPicker = false" @confirm="onConfirm" />
				</van-popup>
			</div>
		</div>
		<div class="agreement" v-show="showBtn">
			<img v-if="agreement_img" src="../assets/gou_yes.png" @click="agreement_cli" />
			<img v-else src="../assets/gou_no.png" @click="agreement_cli" />
			<div>同意革命纪念馆
				<a>用户协议</a> 与
				<a>隐私政策</a>
			</div>
		</div>
		<div class="buttom_bc" @click="buttombc" v-show="showBtn">
			保存
		</div>
		<div class="submission" v-show="submission">
			<div class="sub_text">
				<div>注册成功</div>
				<div @click="toLand">去预约</div>
			</div>
		</div>
		<div class="yin_ts" v-if="yin">
			<div class="buttom_x">
				<img src="../assets/buttom_x.png" />
			</div>
			<div class="text">{{yin_text}}</div>
			<div class="buttom_text" @click="modify">去修改</div>
		</div>
		<div class='view_yinyin' v-if="yin" catchtouchmove="return" @click="modify"></div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	import areaList from '../../static/area.js'
	export default {
		name: 'PersonalRegistration',
		data() {
			return {
				peisonal_documentType: "中国大陆身份证",
				peisonal_name: "",
				peisonal_id: "",
				peisonal_pass: "",
				peisonal_passYes: "",
				yin: false,
				yin_text: "",
				name_reg: "",
				IdNumber_reg: "",
				baseUrl: "",
				agreement_img: false,
				submission: false,
				certificateType: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true,
				test: 'false',
				areaList,
				searchResult: [],
				value: '',
				showPicker: false,
				address: ""
			}
		},
		methods: {
			onConfirm(value) {
				if(value[0].name == '') {
					this.showPicker = false;
				} else if(value[1].name == '' || value[2].name == '') {
					this.yin = true;
					this.yin_text = '请补充所在地址';
				} else {
					this.showPicker = false;
					this.address = value[0].name + '-' + value[1].name + '-' + value[2].name;
				}
			},
			companyClick(item, index) {
				var that = this;
				that.companyIndex = index;
				that.companyName = item.type;
			},
			getFocus() {    
				$("input").on("blur", function() {        
					window.scroll(0, 0);    
				});
			},
			validIdCard(value) {
				var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //加权因子 
				var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2]; //校验码 
				if (/^\d{17}\d|x$/i.test(value)) {
					var sum = 0,
						idx;
					for (var i = 0; i < value.length - 1; i++) {
						// 对前17位数字与权值乘积求和 
						sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
					}
					// 计算模（固定算法） 
					idx = sum % 11;
					// 检验第18为是否与校验码相等 
					return arrValid[idx] == value.substr(17, 1).toUpperCase();
				} else {
					return false;
				}
			},
			buttombc() {
				var that = this;
				if(that.peisonal_documentType == "中国大陆身份证") {
					that.certificateType = 'idcard';
					that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
					that.IdNumber_reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
				} else if(that.peisonal_documentType == "护照") {
					that.certificateType = 'passport';
					that.name_reg = /^([\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}|[a-zA-Z\.\s]{1,20})$/;
					that.IdNumber_reg = /^([a-zA-z]|[0-9]){5,17}$/;
				} else if(that.peisonal_documentType == "港澳居民来往内地通行证") {
					that.certificateType = 'HK_MO_idcard';
					that.name_reg = /^([\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}|[a-zA-Z\.\s]{1,20})$/;
					that.IdNumber_reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/
				} else if(that.peisonal_documentType == "台湾居民来往大陆通行证") {
					that.certificateType = 'TWN_idcard';
					that.name_reg = /^([\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}|[a-zA-Z\.\s]{1,20})$/;
					that.IdNumber_reg = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
				} else if(that.peisonal_documentType == "请选择证件类型") {
					that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
					that.IdNumber_reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
				}
				var pass_reg = /^[a-zA-Z0-9]+$/;
			    var pass = /^(((?=.*[a-z])+(?=.*[A-Z])+(?=.*\d)+)|((?=.*[A-Z])+(?=.*[a-z])+(?=.*[`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|])+)|((?=.*\d)+(?=.*[A-Z])+(?=.*[`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|])+)|((?=.*\d)+(?=.*[a-z])+(?=.*[`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|])+))[A-Za-z\d`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|]{8,20}$/
				if(that.peisonal_documentType == "请选择证件类型") {
					that.yin = true;
					that.yin_text = '请选择证件类型';
				} else if(!that.name_reg.test(that.peisonal_name)) {
					that.yin = true;
					that.yin_text = '姓名认证错误';
				} else if(that.peisonal_documentType == "中国大陆身份证"&&!that.validIdCard(that.peisonal_id)) {
						that.yin = true;
						that.yin_text = '请输入正确的18位身份证号（不包含特殊字符、汉字）';
					}else if(that.peisonal_documentType == "港澳居民来往内地通行证"&&!/^([A-Z]\d{6,10}(\(\w{1}\))?)$/.test(that.peisonal_id)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.peisonal_documentType == "台湾居民来往大陆通行证"&& !/^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/.test(that.peisonal_id)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.peisonal_documentType == "护照"&&!that.IdNumber_reg.test(that.peisonal_id)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.peisonal_pass == "") {
					that.yin = true;
					that.yin_text = '请填写密码';
				}  else if(!pass.test(that.peisonal_pass)) {
					that.yin = true;
					that.yin_text = '请使用数字、大小写字母，特殊字符中3种组合成8-16位密码';
				} else if(that.peisonal_passYes == "" && that.peisonal_passYes != that.peisonal_pass) {
					that.yin = true;
					that.yin_text = '两次密码不一致';
				} else if(that.test == 'false' && that.address == '') {
					that.yin = true;
					that.yin_text = '请选择所在地址';
				} else if(that.agreement_img == false) {
					that.yin = true;
					that.yin_text = '请签订用户协议';
				} else {
					if(that.test == 'false') {
						wclient.view.showLoading();
						wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
						wclient.ajax({
							type: "GET",
							url: that.baseUrl + "/tickets/tickets/ajax?ugi=userUgi&action=createPersonalAccount",
							dataType: "json",
							async: true,
							data: {
								realName: that.peisonal_name,
								certificateType: that.certificateType,
								idNumber: that.peisonal_id,
								password: that.peisonal_pass,
								confirmPassword: that.peisonal_passYes,
								address: that.address
							},
							success: function(data) {
								wclient.view.hideLoading();
								if(data.code == "A00006") {
									that.submission = true;
								}else if(data.code == "A00001"){
									that.yin = true;
									that.yin_text = '系統繁忙，请稍后再试';
								} else {
									that.yin = true;
									that.yin_text = data.errmsg;
								}
							}
						});
					} else if(that.test == 'true') {
						wclient.view.showLoading();
						wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
						wclient.ajax({
							type: "GET",
							url: that.baseUrl + "/tickets/tickets/ajax?ugi=userUgi&action=createPersonalAccount",
							dataType: "json",
							async: true,
							data: {
								realName: that.peisonal_name,
								certificateType: that.certificateType,
								idNumber: that.peisonal_id,
								password: that.peisonal_pass,
								confirmPassword: that.peisonal_passYes
							},
							success: function(data) {
								wclient.view.hideLoading();
								if(data.code == "A00006") {
									that.submission = true;
								}else if(data.code == "A00001"){
									that.yin = true;
									that.yin_text = '系統繁忙，请稍后再试';
								} else {
									that.yin = true;
									that.yin_text = data.errmsg;
								}
							}
						});
					}
				}

			},
			modify() {
				var that = this;
				that.yin = false;
			},
			modify() {
				var that = this;
				that.yin = false;
			},
			agreement_cli() {
				var that = this;
				that.agreement_img = !that.agreement_img
			},
			toLand() {
				var that = this;
				$.ajax({
					type: "post",
					url: that.baseUrl + "/tickets/tickets/ajax?ugi=loginUgi&action=personalLogin",
					async: true,
					data: {
						idNumber: that.peisonal_id,
						password: that.peisonal_passYes
					},
					dataType: 'jsonp',
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					success: function(res) {
						if(res.code == 'A00006') {
							that.$router.push({
								name: 'Logo'
							});
						} else {
							that.success = true;
							that.success_img = false;
							that.success_text = res.errmsg
						}
					}
				});
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.test = 'false';
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.test = 'false';
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.test = 'true';
			}
			that.baseUrl = baseUrl;
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}

			}
		}
	}
</script>

<style scoped>
	.information {
		width: 80%;
		border-radius: 15px;
		overflow: hidden;
		padding: 0 5%;
		margin: 5% auto 30%;
		-webkit-overflow-scrolling: touch;
		background: white;
	}
		.se{
	    width: 75%;
    line-height: 60px;
    font-size: 16px;
}
	.img_gr {
		width: 22px;
	}
	
	.img_sfz {
		width: 22px;
		margin-left: -2px;
	}
	
	.img_sjh {
		width: 16px;
	}
	
	.information_div {
		display: flex;
		border-bottom: 1px #eee solid;
		align-items: center;
		justify-content: space-between;
	}
	
	.information_div:last-child {
		border: none;
	}
	
	.information_div_div {
		width: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	input {
		border: none;
		outline: none;
		font-size: 16px;
		width: 85%;
		line-height: 60px;
	}
	
	select {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border: none;
		outline: none;
		font-size: 16px;
		color: #B1B1B1;
		width: 72%;
		background: white !important;
	}
	
	.information_div>img {
		width: 5%;
	}
	
	.buttom_bc {
		width: 60%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		;
		line-height: 39px;
		border-radius: 48px;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: center;
		justify-content: center;
		color: #fff;
		font-size: 16px;
		margin: 0 auto;
		position: fixed;
		left: 50%;
		bottom: 2%;
		margin-left: -30%;
	}
	
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #B1B1B1;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #B1B1B1;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #B1B1B1;
	}
	
	input::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #B1B1B1;
	}
	
	.agreement {
		width: 77%;
		font-size: 13px;
		color: #7F7F7F;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		bottom: 10%;
		left: 11.5%;
	}
	
	.agreement img {
		width: 7%;
		margin-right: 10px;
		margin-top: -1px;
	}
	
	.agreement a {
		color: #92C0FF;
	}
	
	.view_yinyin {
		width: 100vh;
		height: 100vh;
		background: rgba(0, 0, 0, .3);
		position: fixed;
		top: 0;
		overflow: hidden;
		z-index: 998;
	}
	
	.yin_ts {
		position: fixed;
		top: 25%;
		background: #fff;
		z-index: 999;
		border-radius: 20px;
		width: 66%;
		left: 17%;
		text-align: center;
	}
	
	.buttom_x {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 30px 0;
	}
	
	.buttom_x img {
		width: 60px;
	}
	
	.text {
		font-size: 18px;
		font-family: PingFangSC-Medium;
		font-weight: 600;
		color: rgba(55, 55, 55, 1);
		width: 80%;
		margin: 0 auto;
	}
	
	.title {
		font-weight: 400;
		color: rgba(164, 164, 164, 1);
		font-size: 16px;
		line-height: 30px;
		border-bottom: 1px rgb(225, 225, 225) solid;
		padding-bottom: 10px;
	}
	
	.buttom_text {
		color: rgba(228, 4, 4, 1);
		line-height: 50px;
		font-size: 16px;
		font-weight: bold;
		border-top: 1px solid #eee;
		margin-top: 20px;
	}
	
	.submission {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
	}
	
	.sub_text {
		width: 64%;
		margin: 34vh auto 0;
		background: white;
		border-radius: 10px;
	}
	
	.sub_text div:nth-child(1) {
		text-align: center;
		width: 90%;
		padding: 25px 5%;
		font-weight: 400;
	}
	
	.sub_text div:nth-child(2) {
		text-align: center;
		width: 100%;
		font-weight: 400;
		line-height: 40px;
		border-top: 1px solid #CDCDCD;
		color: rgba(207, 18, 14, 1);
	}
	
	>>>.van-cell {
		padding: 0;
		width: 87%;
	}
	
	>>>.van-field__label {
		display: none !important;
	}
	
	>>>.van-field__control {
		font-size: 16px;
		border: none;
		text-indent: 6px;
	}
	
	>>>.van-overlay {
		z-index: 996 !important;
	}
	
	>>>.van-popup {
		z-index: 997 !important;
	}
	
	>>>.van-field__control {
		line-height: 60px;
	}
</style>


// WEBPACK FOOTER //
// src/components/personalRegistration.vue